module.exports = __webpack_public_path__ + "static/media/dozer.5fbde85a.svg";